import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext({ branding: null, refresh: () => {} });
export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);
  const refresh = useCallback(async () => {
    try { const r = await api.get("/branding/public"); setBranding(r.data); } catch { /* stays neutral */ }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <BrandingContext.Provider value={{ branding, refresh }}>{children}</BrandingContext.Provider>;
}
